import { render, staticRenderFns } from "./text-bars2.vue?vue&type=template&id=2b83bec8&scoped=true&"
var script = {}
import style0 from "./text-bars2.vue?vue&type=style&index=0&id=2b83bec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83bec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b83bec8')) {
      api.createRecord('2b83bec8', component.options)
    } else {
      api.reload('2b83bec8', component.options)
    }
    module.hot.accept("./text-bars2.vue?vue&type=template&id=2b83bec8&scoped=true&", function () {
      api.rerender('2b83bec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-bars2.vue"
export default component.exports